import {useState} from "react";
import ErrorDisplay from "../errorDisplay";
import PropTypes from "prop-types";

const UploadFile = (props) => {
  const {
    label,
    id,
    key,
    name,
    note,
    onChange,
    error,
    value,
    noFileMessage
  } = props;

  const idValue = id || label || name;
  const [hideUploadBox, setHideUploadBox] = useState(true);
  const errorId = `upload-error-${idValue}`;
  const buttonId = `upload-button-${idValue}`;
  const noteId = `upload-note-${idValue}`;
  const fileboxId = `upload-filebox-${idValue}`;

  const hasError = Boolean(error);

  return (
    <div className='upload-file-container'>
      <div className='upload-button'>
        <button id={buttonId} className='tes-button' aria-labelledby={noteId} onClick={(e) => {e.preventDefault(); setHideUploadBox(!hideUploadBox)}}>{label}</button>
        {noFileMessage ? <span className='upload-nofile-message'>{noFileMessage}</span> : ''}
      </div>
      {note && <div id={noteId} className='upload-file-note'>{note}</div>}
      <div className={hideUploadBox ? 'upload-filebox sr-hide' : 'upload-filebox'}>
        <label htmlFor={fileboxId} className='sr-hide'>{label}</label> <input id={fileboxId} className={hideUploadBox ? 'upload-input upload-input-hide' : 'upload-input'} key={fileboxId} type='file' onChange={(e) => {onChange((e.target.files[0]))}}/>
      </div>
      { hasError && <ErrorDisplay errors={[error]} id={errorId}/> }
    </div>
  )
};

UploadFile.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
  name: PropTypes.string,
  note: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.object
}

export default UploadFile;